import React from "react";
import { Table } from "antd";
import { Pagination } from "react-bootstrap";
import { BaseComponent } from "..";
import CustomExpand from "../CustomExpand";
import moment from "moment";

export default class CustomTableExpand extends BaseComponent {
  res_size_num = 20;

  constructor(props) {
    super(props);
    this.state = {
      totalPages: 1,
      isItemOpen: {},
      isItemExpand: {},
      currentPage: props.currentPage || 1,
      expandedRows: {},
      activeColumns: props.columns || [],
    };
  }

  getPages() {
    const result = [];
    const totalPages = this.props.totalPages || 1;
    for (let i = 1; i <= totalPages; i++) {
      result.push(i);
    }
    return result;
  }

  setPage(page) {
    if (page !== this.state.currentPage) {
      this.setState({
        currentPage: page,
      });
      if (this.props.onPagination) {
        this.props.onPagination(page);
      }
    }
  }

  onOpenItem = (index) => {
    this.setState((prevState) => {
      const newIsItemOpen = { ...prevState.isItemOpen };
      newIsItemOpen[index] = !newIsItemOpen[index];
      return { isItemOpen: newIsItemOpen };
    });
  };

  onExpandDetails = (index) => {
    window.scroll({
      top: 100,
      left: 100,
      behavior: "smooth",
    });
    this.setState((prevState) => {
      const newIsItemExpand = { ...prevState.isItemExpand };
      newIsItemExpand[index] = !newIsItemExpand[index];
      return { isItemExpand: newIsItemExpand };
    });
  };

  render() {
    const { currentPage, isItemOpen, isItemExpand } = this.state;
    const { props } = this;

    return (
      <>
        {!props.data || !props.data.length ? (
          <div style={{ padding: "30px" }}>
            {"לא נמצאו תוצאות" || this.label("no_data")}
            {props.totalPages > 1 && (
              <Pagination
                style={{ flexWrap: "wrap" }}
                size="sm"
                className="d-flex justify-content-center flex-row-reverse p-4"
              >
                {this.getPages().map((page) => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => this.setPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                ))}
              </Pagination>
            )}
          </div>
        ) : (
          <>
            {!props.isHideTableTop && (
              <div className={`table-top ${props.asOfDate ? "date-data" : ""}`}>
                <div className="amount-results">
                  <span>{"נמצאו"}</span>
                  <span className="number">{props.totalCount || 0}</span>
                  <span>{"תוצאות"}</span>
                </div>
                <div
                  className={`info-container ${props.asOfDate ? "w100p" : ""}`}
                >
                  {props.asOfDate && (
                    <div>
                      <p value="data_correct_date" />{" "}
                      {moment(props.asOfDate).format("DD/MM/YYYY")}
                    </div>
                  )}
                  {!props.isHideExport &&
                    (props.isLoadingExcel ? (
                      <div style={{ textAlign: "center", paddingTop: "2em" }}>
                        <img
                          src="/img/loading.gif"
                          alt="loading"
                          style={{ height: "50px" }}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() =>
                          props.onExportExcel && props.onExportExcel()
                        }
                        className="excel-download"
                        style={{ marginLeft: "10px" }}
                      >
                        <img src="/img/excel-icon.png" alt="excel" />
                        <span className="excel-btn">{"יצא לאקסל"}</span>
                      </div>
                    ))}
                  {props.showExportPdf &&
                    (props.isLoadingPdf ? (
                      <div style={{ textAlign: "center" }}>
                        <img src="/img/loading.gif" alt="loading" />
                      </div>
                    ) : (
                      <div
                        onClick={() => props.onExportPdf && props.onExportPdf()}
                        className="excel-download"
                      >
                        {/* <img src={require("images/adobe-icon.png")} alt="pdf" /> */}
                        <span className="excel-btn">
                          <p value="ייצוא לPDF" />
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            )}

            <Table
              className={props.groupedColumns ? "grouped-table" : ""}
              pagination={{ pageSize: this.res_size_num }}
              expandIconColumnIndex={
                props.groupedColumns && !props.expandeData
                  ? -1
                  : props.expandedIdx
              }
              expandIconAsCell={false}
              expandedRowRender={(cell, idx) => (
                <CustomExpand
                  expandedName={"gggg"}
                  data={cell}
                  idx={idx}
                  expandedRowRender={props.expandedRowRender}
                />
              )}
              columns={props.groupedColumns || props.columns}
              dataSource={props.data}
              expandIcon={({ expanded, onExpand, record }) => {
                if (!props.isExpande) return;
                return expanded ? (
                  <button
                    onClick={(e) => onExpand(record, e)}
                    className={`btn-status btn-${record.key} open`}
                  >
                    <p>סגור</p>
                  </button>
                ) : (
                  <button
                    onClick={(e) => onExpand(record, e)}
                    className="btn-status"
                  >
                    {props.btnTxt || "עדכן סטטוס"}
                  </button>
                );
              }}
            />
            <div className="table-container-mobile">
              {props.data &&
                props.data.map((item, idx) => {
                  return (
                    <div key={idx} className="table-item">
                      {isItemExpand[idx] && (
                        <section className="expand-mobile">
                          <div className="close-container b-line">
                            <span className="text">
                              <p value="close" />
                            </span>
                            <div
                              onClick={() => this.onExpandDetails(idx)}
                              className="close-icon"
                            >
                              <div className="vertical-line rotate" />
                              <div className="horizontal-line" />
                            </div>
                          </div>
                          {
                            <CustomExpand
                              expandeName={"ggg"}
                              data={item}
                              idx={item.key}
                              expandedRowRender={props.expandedRowRender}
                            />
                          }
                        </section>
                      )}
                      <div className="item-header">
                        <span className="text">
                          {props.groupedColumns
                            ? props.groupedColumns[0]?.children[0]?.title ||
                              "Column 1"
                            : props.columns[0]?.title || "Column 1"}
                        </span>
                        <span className="text">
                          {props.groupedColumns
                            ? props.groupedColumns[0]?.children[1]?.title ||
                              "Column 2"
                            : props.columns[1]?.title || "Column 2"}
                        </span>
                      </div>
                      <div
                        className={`item-content ${
                          isItemOpen[idx] ? "" : "d-none"
                        } b-line `}
                      >
                        {(props.groupedColumns
                          ? props.groupedColumns.flatMap(
                              (group) => group.children
                            )
                          : props.columns
                        ).map((col, i) => {
                          if (i === 1) return;
                          const firstCol = props.groupedColumns
                            ? props.groupedColumns[0]?.children[0]
                            : props.columns[0];
                          const secondCol = props.groupedColumns
                            ? props.groupedColumns[0]?.children[1]
                            : props.columns[1];

                          const title = !i
                            ? firstCol?.render
                              ? firstCol.render(item[col.dataIndex])
                              : item[col.dataIndex]
                            : col?.title;
                          const value = !i
                            ? item[secondCol?.dataIndex]
                            : col?.render
                            ? col.render(item[col.dataIndex], item)
                            : item[col?.dataIndex];
                          return title ? (
                            <div key={i} className="details">
                              <span className="title">{title}</span>
                              <span
                                className={`value ${!i ? "bold-value" : ""}`}
                              >
                                {value}
                              </span>
                            </div>
                          ) : col?.render ? (
                            col.render(item[col.dataIndex], item)
                          ) : (
                            <button
                              key={i}
                              onClick={() => {
                                if (props.isExpande) this.onExpandDetails(idx);
                                else {
                                  props.onBtnClick &&
                                    props.onBtnClick(item[props.onClickBy]);
                                }
                              }}
                              className="btn-status"
                            >
                              {props.btnTxt || "עדכן סטטוס"}
                            </button>
                          );
                        })}
                      </div>
                      <div className="item-footer">
                        <div
                          className={`text-container ${
                            !isItemOpen[idx] ? "" : "d-none"
                          }`}
                        >
                          <span className="text">
                            {(() => {
                              const firstCol = props.groupedColumns
                                ? props.groupedColumns[0]?.children[0]
                                : props.columns[0];
                              return firstCol?.render
                                ? firstCol.render(
                                    props.data[idx][firstCol.dataIndex]
                                  )
                                : props.data[idx][firstCol?.dataIndex];
                            })()}
                          </span>
                          <span className="text">
                            {(() => {
                              const secondCol = props.groupedColumns
                                ? props.groupedColumns[0]?.children[1]
                                : props.columns[1];
                              return props.data[idx][secondCol?.dataIndex];
                            })()}
                          </span>
                        </div>
                        <div className="btn-container">
                          <button
                            onClick={() => this.onOpenItem(idx)}
                            className={`row-toggle ${
                              isItemOpen[idx] ? "open" : ""
                            }`}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            {props.data.length > 0 && props.totalPages > 1 && (
              <Pagination
                style={{ flexWrap: "wrap" }}
                size="sm"
                className="d-flex justify-content-center flex-row-reverse p-4"
              >
                {this.getPages().map((page) => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => this.setPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                ))}
              </Pagination>
            )}
          </>
        )}
      </>
    );
  }
}
